import Decimal from 'decimal.js';

interface CalcToProduceValueArgs {
  percentage: number;
  limit?: number;
  incommingStorage: number;
  localStock: number;
  max: number;
}

const calcToProduceValue = ({
  percentage,
  limit,
  incommingStorage,
  localStock,
  max,
}: CalcToProduceValueArgs): number => {
  if (limit) {
    const remainsToProduce = Math.max(incommingStorage + localStock, 0);
    const residue = limit - remainsToProduce;
    const available = Math.min(residue, max);

    if (available <= 0) {
      return 0;
    }
    const decimalResidue = new Decimal(available);
    const percentageCof = new Decimal(percentage).div(100);
    const toAdd = Math.round(decimalResidue.mul(percentageCof).toNumber());

    return toAdd;
  }

  return 0;
};

export { calcToProduceValue };
